export const toDataURL = (src, outputFormat) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    // eslint-disable-next-line
    img.onload = function () {
      const canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = this.naturalHeight;
      canvas.width = this.naturalWidth;
      ctx.drawImage(this, 0, 0);
      const dataURL = canvas.toDataURL(outputFormat);
      resolve(dataURL);
    };
    img.src = src;
  });
};

export const getImageDimensions = (file) => {
  return new Promise((resolve) => {
    const i = new Image();
    i.onload = () => {
      resolve({ width: i.width, height: i.height });
    };
    i.src = file;
  });
};
